import { useQuery } from 'react-query'
import React from "react";
import { fetchTrialSignUpsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

function TotalsByRep({ date }) {
    const fetchData = async () => {
        const { data } = await fetchTrialSignUpsExplorer('totalsByRep', date);
        if (data.result && data.result.data) return data.result;
        return { ...data.result, data: [] }; // Ensure data is always an array
    };

    const { data, error, isError, isLoading } = useQuery(
        ['totalsByRep', date],
        fetchData,
        {
            refetchOnWindowFocus: false,
        }
    );
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer key={"totalsByRep" + date}  {...dataProps } />
}
export default TotalsByRep